import { render, staticRenderFns } from "./PricingFaq.vue?vue&type=template&id=280ec29d&scoped=true&"
import script from "./PricingFaq.vue?vue&type=script&lang=js&"
export * from "./PricingFaq.vue?vue&type=script&lang=js&"
import style0 from "./PricingFaq.vue?vue&type=style&index=0&id=280ec29d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280ec29d",
  null
  
)

export default component.exports